// extracted by mini-css-extract-plugin
export default {"header":"NewUserHeader_header__ME7yt","breathing":"NewUserHeader_breathing__G7nQV"};